import React, { useState } from 'react'
import LineGraphSummary from './LineGraphSummary'
import { useQuery } from '@tanstack/react-query';
import { getMonthlyHitsSummary } from '../../../services/finance/payments-service';
import { Alert, Spinner } from 'react-bootstrap';

function GraphWidget() {
    const [labels, setLabels] = useState([])
    const [data, setData] = useState([])
    const { isLoading, isError, error, data:hits, isFetching, isPreviousData } =
        useQuery({
            queryKey: ["finance", "hitsummary"],
            queryFn: () => getMonthlyHitsSummary(),
            onSuccess: (response) => {
                let labels_list = []
                let value_list = []
                console.log("monthly", response.data)
                let data = response.data
                for(const item in data){
                    console.log(data[item])
                    labels_list.push(data[item].label)
                    value_list.push(data[item].total)
                }
                console.log("labels", labels_list)
                setLabels(labels_list)
                setData(value_list)
            }
    });

  return (
    <div>
        {isLoading ? (
            <Spinner />
          ) : isError ? (
            <Alert variant='danger'>Error: {error.message}</Alert>
          ) : (
                <LineGraphSummary labels={labels} data={data} />
          )}
    </div>
  )
}

export default GraphWidget